// TODO: This should live in the eligibility file folder as a component called selector
import { service } from '@ember/service';
import { t } from 'ember-intl';
import { tracked } from '@glimmer/tracking';
import Component from '@glimmer/component';
import fileQueue from 'ember-file-upload/helpers/file-queue';
import TioLoadingSpinner from './tio/loading-spinner.gts';
import type CompanyModel from '../models/company.ts';
import type RouterService from '@ember/routing/router-service';
import type Store from '@ember-data/store';
import { type UploadFile } from 'ember-file-upload';
import type EligibilityFileJobLogModel from '../models/eligibility-file-job-log.ts';
import { Switch } from 'tio-ui/components/forms';
import { VStack } from 'tio-ui/components/layout';

interface EligibilityFileSelectorSignature {
  Args: {
    toggleFileSelected: (item: EligibilityFileJobLogModel) => void;
    company: CompanyModel;
  };
  Element: HTMLDivElement;
}

export default class EligibilityFileSelectorComponent extends Component<EligibilityFileSelectorSignature> {
  @service declare store: Store;
  @service declare router: RouterService;

  @tracked fileName = '';
  @tracked isLoading = false;
  @tracked showError = false;
  @tracked isForced = false;

  get isAdmin() {
    // TODO: There are other services to figure this out. If routes are moved around this would break.
    return !!this.router.currentRouteName?.includes('authenticated.eligibility.index');
  }

  get showManualToggle() {
    return this.isAdmin && this.isLoading === false;
  }

  fileSelected = async (uploadFile: UploadFile) => {
    const strategy = this.isForced ? 'MANUAL_FORCE_UPDATE' : 'MANUAL';
    const { legacyId, id } = this.args.company;
    const record = await this.store
      .adapterFor('eligibility-file-job-log')
      .getUploadRecord(uploadFile.file.name, legacyId, id, strategy);

    this.args.toggleFileSelected(record);
    this.fileName = uploadFile.file.name;
  };

  toggleIsForced = (value: boolean) => {
    this.isForced = value;
  };

  <template>
    <VStack ...attributes>
      {{#if this.showManualToggle}}
        <div class="flex gap-2">
          <label>{{t "eligibility_files.manual"}}</label>
          <Switch
            @label={{t "eligibility_files.forced"}}
            @intent="success"
            @isSelected={{this.isForced}}
            @onChange={{this.toggleIsForced}}
          />
        </div>
      {{/if}}
      {{#if this.fileName}}
        {{this.fileName}}
      {{else}}
        {{#let
          (fileQueue name="eligibility-upload-queue" onFileAdded=this.fileSelected)
          as |queue|
        }}
          {{#if this.isLoading}}
            <TioLoadingSpinner />
          {{else}}
            <label for="file-upload">
              <div
                class="text-ocean-600 hover:text-ocean-800 cursor-pointer border border-gray-200 border-ocean-600 !inline-block p-4"
              >
                {{t "eligibility_files.select_file"}}
              </div>
            </label>
            <input id="file-upload" type="file" accept=".csv" {{queue.selectFile}} class="hidden" />
          {{/if}}
        {{/let}}
      {{/if}}
      {{#if this.showError}}
        <div class="text-red-600 text-sm font-semibold">
          {{t "eligibility_files.file_upload_error"}}
        </div>
      {{/if}}
    </VStack>
  </template>
}
